// external
import React, { useEffect, useState } from "react";
import { PropTypes } from "prop-types";

// styles
import default_avatar from "resources/default_avatar.png";

function NavbarAvatarImage({ avatar_url }) {
  const [style, setStyle] = useState(null);

  useEffect(() => {
    setStyle(
      avatar_url
        ? { backgroundColor: "var(--card)" }
        : { backgroundImage: `url(${default_avatar})` },
    );
  }, [avatar_url]);

  return (
    <div
      className="navbar-avatar-image navbar-avatar-image-margin"
      style={style}
    >
      <div
        className="navbar-avatar-image"
        style={{
          backgroundImage: `url(${avatar_url})`,
        }}
      />
    </div>
  );
}

NavbarAvatarImage.propTypes = {
  avatar_url: PropTypes.string,
};

export default NavbarAvatarImage;
